module.exports = __webpack_public_path__ + "static/img/yes-logo.426f0b32.png";